import React, { useEffect } from "react";
import { serverConfig } from "../ApiSearchPath/ApiSearchPath";
//import { useLocation } from 'react-router-dom';
import { DoctorsService } from "./Services/DoctorsService";
import axiosInstance from "../api/auth/axiosInstance";
import { useState } from "react";
import { useSearchParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from "swiper/modules";
import { useLocation } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation"; // optional, for nav arrows
import 'swiper/css/pagination'; // optional, for pagination
// TODO: Adjust the import path to match where you defined DoctorsService

export default function DoctorProfile() {
  useEffect(() => {
    const scriptUrls = [
      "assets/js/jquery-3.7.1.min.js",
      "assets/js/bootstrap.bundle.min.js",
      "assets/js/owl.carousel.min.js",
      "assets/plugins/fancybox/jquery.fancybox.min.js",
      "assets/js/script.js"
    ];

    let isCancelled = false;

    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.async = false;
          script.onload = () => {
            console.log(`Loaded: ${url}`);
            resolve();
          };
          script.onerror = () => {
            console.error(`Failed to load: ${url}`);
            reject();
          };
          document.body.appendChild(script);
        });
      }

      // Now init plugins after scripts are loaded
      if (!isCancelled) {
        // if (window.AOS) {
        //   window.AOS.init();
        // }

        if (window.$ && typeof window.$.fn.datetimepicker === 'function') {
          window.$('.datetimepicker').datetimepicker();
        }

        if (typeof window.initBackToTop === 'function') {
          window.initBackToTop(); // assuming your backToTop script defines this
        }

        console.log('All scripts loaded and initialized.');
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
    };
  }, []);

  const [searchParams] = useSearchParams();
  const doctorId = searchParams.get("query");

  const [doctor, setDoctor] = useState(null);
  const [loading, setLoading] = useState(true);

  // ← THIS IS THE API CALL YOU WANTED (runs AFTER navigation, triggered by query)
  useEffect(() => {
    const fetchMainDoctor = async () => {
      if (!doctorId) {
        setLoading(false);
        return;
      }

      try {
        const response = await DoctorsService.searchDoctors(doctorId);
        const doctorData = response.data;
        console.log("Doctor data received (from query):", doctorData);
        setDoctor(doctorData);
      } catch (error) {
        console.error("Error fetching doctor:", error);
        setDoctor(null);
      } finally {
        setLoading(false);
      }
    };

    fetchMainDoctor();
  }, [doctorId]);

  const handleClick = (e, divid) => {
    e.preventDefault(); // This prevents full page reload
    document.getElementById(divid)?.scrollIntoView({ behavior: "smooth" });
  };



  const [experiences, setExperiences] = useState([]);
  const [specialities, setSpecialities] = useState([]);
  const [services, setServices] = useState([]);
  const [availability, setAvailability] = useState([]);
  const [appointmentTypes, setAppointmentTypes] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    if (doctor?.userId) {
      console.log("Fetching experience data for userId:", doctor.userId);
      axiosInstance.get(`/experience/doctor/user/${doctor.userId}`, {
        headers: { authType: "PreLogin" },
      }
      )
        .then(response => {
          const data = Array.isArray(response.data) ? response.data : [response.data];
          setExperiences(data);
        })
        .catch(error => {
          console.error("Error fetching experience data:", error);
        });
    }
  }, [doctor?.userId]);
  const getUserSpecialities = async (userId) => {
    console.log("Fetching specialities for userId:", userId);
    try {
      const response = await axiosInstance.get(`/user-speciality/doctor/speciality/${userId}`, {
        headers: { authType: "PreLogin" },
      });
      const rawData = response.data?.data;
      if (Array.isArray(rawData) && Array.isArray(rawData[0])) {
        setSpecialities(rawData[0]);
      } else {
        setSpecialities([]);
      }
    } catch (error) {
      console.error(error + 'Error fetching specialities:', error);
      throw error;
    }
  };
  const getUserServices = async (userId) => {
    try {
      const response = await axiosInstance.get(`/user-services/doctor/service/${userId}`, {
        headers: { authType: "PreLogin" },
      });
      const rawData = response.data?.data;
      if (Array.isArray(rawData) && Array.isArray(rawData[0])) {
        setServices(rawData[0]);
      } else {
        setServices([]);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
      setServices([]);
    }
  };


  const getAvailability = async (userId) => {
    try {
      const res = await axiosInstance.get(`/available-tt/doctor/by-user/${userId}`, {
        headers: { authType: "PreLogin" },
      });
      const data = res.data;
      if (Array.isArray(data)) {
        const activeSlots = data.filter(item => item.isActive === "Y" && item.isOpen === "Y");
        setAvailability(activeSlots);
      } else {
        setAvailability([]);
      }
    } catch (err) {
      console.error("Error fetching availability", err);
    }
  };

  const fetchAppointmentData = async (userId) => {
    if (userId) {
      axiosInstance.get(`/users-appointment-types/doctor/${userId}`, {
        headers: { authType: "PreLogin" },
      })
        .then(response => setAppointmentTypes(response.data))
        .catch(err => console.error('Failed to fetch appointment types', err));
    }

  };
  const fetchLogo = async (userId) => {
    if (userId) {
      try {
        const response = await axiosInstance.get(`/company/doctor/logo/user/${userId}`, {
          headers: { authType: "PreLogin" },
        });
        const imageName = response.data;

        // Check if you really got a file name
        if (imageName) {
          setLogoUrl(imageName); // logoUrl = "logo1.jpg"
        }
      } catch (error) {
        console.error("Error fetching logo:", error);
      }
    }
  };


  useEffect(() => {
    if (doctor?.userId) {
      getUserSpecialities(doctor.userId);
      getUserServices(doctor.userId);
      getAvailability(doctor.userId);
      fetchAppointmentData(doctor.userId);
      fetchLogo(doctor.userId);
    }
  }, [doctor?.userId]);

  // const formatTime = (timeStr) => {
  //   const [hour, minute] = timeStr.split(':');
  //   const date = new Date();
  //   date.setHours(hour, minute);
  //   return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  // };
  const getTodayName = () => {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return days[new Date().getDay()];
  };

  const isTodayAvailable = availability.some(slot =>
    slot.day?.toLowerCase() === getTodayName().toLowerCase() && slot.isOpen === "Y"
  );
  // const UnavailableStyle = {
  //   backgroundColor: `#F32013`,
  //   color: "#fff",
  // };
  // const availableStyle = {
  //   color: "#fff"
  // }

  const formatTime = (time) => {
    if (!time) return '';

    const [hours, minutes] = time.split(':');
    const date = new Date();
    date.setHours(+hours);
    date.setMinutes(+minutes);

    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }).replace('AM', 'A.M.').replace('PM', 'P.M.');
  };

  const { pathname } = useLocation();

useEffect(() => {
  window.scrollTo(0, 0);
}, [pathname]);
  return (
    <>
      <style>{`
      .content {
 padding-top:2px;
 margin-top:2px;
}
 .error-title {
  color: #ed4e2b !important;
}
 .doctor-img {
    width:100%;
    height: auto;
    text-align: center;
    margin: 0 auto !important;
    

  }
      .doctor-img img {
  width: 100%;
  height: auto;
  border: 1px solid #ddd;
  padding: 5px;
  margin-left:5%,
  margin-right:5%
  border-radius: 50%;
}
.clinic-img{
   width:100% !important;
  //  height:200px !important;
}
@media (max-width: 767px) {
  .doctor-img img {
    margin: 0 auto !important;
    display: block;
    border-radius: 50%;
    height: 200px !important;
    width: 200px !important;
  }
}
@media (max-width: 767px) {

  .contact-doctors {
    display: flex;
    flex-wrap: nowrap;      /* keep in one row */
    overflow-x: auto;       /* enable scrolling */
    overflow-y: hidden;
    gap: 12px;
    padding-bottom: 8px;
    -webkit-overflow-scrolling: touch; /* smooth scroll */
  }

  .contact-doctors li {
    flex: 0 0 auto;         /* prevent shrinking */
    list-style: none;
  }

  .contact-doctors li a {
    display: flex;
    align-items: center;
    white-space: nowrap;
    padding: 8px 14px;
    border-radius: 25px;
    background: #f5f6fa;
  }

  /* Hide scrollbar */
  .contact-doctors::-webkit-scrollbar {
    height: 4px;
  }

  .contact-doctors::-webkit-scrollbar-thumb {
    background: transparent;
  }
 
}
@media (max-width: 768px) {
  .bottom-book-btn {
    // flex-direction: column;
    align-items: flex-start;
  }
   .slick-prev {
      left:1px !important;
    }
    .slick-next{
      right:1px !important;
  }
  .clinic-booking {
    width: 100%;
  }
  .apt-btn {
    
    text-align: center;
  }
}


      /* ===== Mobile Scrollable Tabs ===== */
.information-title-list {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  // gap: 10px;
  padding-bottom: 5px;
  scrollbar-width: none; /* Firefox */
}

/* Hide scrollbar */
.information-title-list::-webkit-scrollbar {
  display: none;
}

.information-title-list li {
  flex: 0 0 auto;
}

.information-title-list li a {
  display: inline-block;
  padding: 8px 15px;
  border-radius: 25px;
  background: #f3f6ff;
  font-size: 14px;
  transition: 0.3s;
}

/* Active Tab */
.information-title-list li.active a {
  background: #0d6efd;
  color: #fff;
}
  .doctors-detailed-info {
  position: relative;
}

.information-title-list {
  // position: sticky;
  top: 70px;
  background: #fff;
  z-index: 100;
}
  .information-title-list {
  display: flex;
  overflow-x: auto;   /* enables horizontal scroll */
  white-space: nowrap;
  padding: 0;
  margin: 0;
  list-style: none;
  scrollbar-width: thin; /* Firefox */
}

.information-title-list li {
  flex: 0 0 auto; /* prevent items from shrinking */
}

.information-title-list li a {
  display: inline-block;
  padding: 10px 15px;
  text-decoration: none;
}

/* Optional: Hide scrollbar (Chrome, Edge, Safari) */
.information-title-list::-webkit-scrollbar {
  height: 6px;
}

.information-title-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}
  /* Services one line */
.special-links {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 10px;
  padding: 0;
  list-style: none;
  scrollbar-width: none;
}

.special-links::-webkit-scrollbar {
  display: none;
}

.special-links li {
  flex: 0 0 auto;
}

.special-links li a {
  display: inline-block;
  padding: 8px 16px;
  background: #f1f5ff;
  border-radius: 20px;
  white-space: nowrap;
  font-size: 14px;
  transition: 0.3s;
}

.special-links li a:hover {
  background: #0d6efd;
  color: #fff;
}
  @media (min-width: 992px) {
  .special-links {
    flex-wrap: wrap;
    overflow-x: hidden;
  }
}
  /* One line horizontal scroll */
.special-links {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 10px;
  padding: 0;
  list-style: none;
  margin: 0;
  scrollbar-width: none;
}

.special-links::-webkit-scrollbar {
  display: none;
}

.special-links li {
  flex: 0 0 auto;
}

.special-links li a {
  display: inline-block;
  padding: 8px 18px;
  background: #f1f5ff;
  border-radius: 25px;
  white-space: nowrap;
  font-size: 14px;
  color: #333;
  transition: 0.3s;
}

.special-links li a:hover {
  background: #0d6efd;
  color: #fff;
}@media (min-width: 992px) {
  .special-links {
    flex-wrap: wrap;
    overflow-x: hidden;
  }
    .doc-info-cont{
    mtrgin-top: 20px !important;
    padding: 10px !important;
    }
}
      @media (max-width: 600px) {
      .doc-info-cont{
    padding-top: 20px !important;
    }
      }


/* Scroll animation */
.scroll-css {
  display: flex;
  flex-wrap: nowrap;
  animation: scrollLeft 15s linear infinite;
}

/* Animation */
@keyframes scrollLeft {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* Mobile only */
@media (max-width: 768px) {
  .scroll-css {
    animation: scrollLeft 15s linear infinite;
  }
}

/* Desktop stop animation */
@media (min-width: 769px) {
  .scroll-css {
    animation: none;
    flex-wrap: wrap;
  }
}
  
    `}</style>
      {(loading) ?
        (<>
          {/* Breadcrumb still shows (looks professional) */}
          <div className="breadcrumb-bar">
            <div className="container">
              <div className="row align-items-center inner-banner">
                <div className="col-md-12 col-12 text-center">
                  <nav aria-label="breadcrumb" className="page-breadcrumb">
                    {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/main-page"><i className="isax isax-home-15" /></a></li>
                    <li className="breadcrumb-item" aria-current="page">Doctors</li>
                    <li className="breadcrumb-item active">Doctor Profile</li>
                  </ol> */}
                    <h2 className="breadcrumb-title">Doctor Profile</h2>
                  </nav>
                </div>
              </div>
            </div>
            <div className="breadcrumb-bg">
              <img src="assets/img/bg/breadcrumb-bg-01.png" alt="img" className="breadcrumb-bg-01" />
              <img src="assets/img/bg/breadcrumb-bg-02.png" alt="img" className="breadcrumb-bg-02" />
              <img src="assets/img/bg/breadcrumb-icon.png" alt="img" className="breadcrumb-bg-03" />
              <img src="assets/img/bg/breadcrumb-icon.png" alt="img" className="breadcrumb-bg-04" />
            </div>
          </div>

          {/* Centered Loading Processor */}
          <div className="content">
            <div className="container">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "60vh" }}
              >
                <div className="text-center">
                  {/* Beautiful spinning loader using your existing Font Awesome */}
                  <i
                    className="fa-solid fa-spinner fa-spin fa-4x mb-4"
                    style={{ color: "#0d6efd" }}
                  />
                  <h4 className="mb-2">Loading Doctor Profile...</h4>
                  <p className="text-muted">Please wait while we fetch the details</p>
                </div>
              </div>
            </div>
          </div>
        </>)
        : ((doctor?.showIdentity === "N") || (!doctor?.showIdentity)
          || (!doctor?.showCompanyIdentity) ||
          (doctor?.showCompanyIdentity === "N") ||
          (doctor?.kycAccept !=="Y") || (!doctor?.kycAccept)) ? (<>
            {/* Breadcrumb still shows (looks professional) */}
            <div className="breadcrumb-bar">
              <div className="container">
                <div className="row align-items-center inner-banner">
                  <div className="col-md-12 col-12 text-center">
                    <nav aria-label="breadcrumb" className="page-breadcrumb">
                      {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/main-page"><i className="isax isax-home-15" /></a></li>
                    <li className="breadcrumb-item" aria-current="page">Doctors</li>
                    <li className="breadcrumb-item active">Doctor Profile</li>
                  </ol> */}
                      <h2 className="breadcrumb-title">Doctor Profile</h2>
                    </nav>
                  </div>
                </div>
              </div>

            </div>

            {/* Centered Loading Processor */}
            <div className="content" >
              <div className="container">
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: "20vh" }}
                >
                  <div className="text-center">
                    {/* Beautiful spinning loader using your existing Font Awesome */}
                    {/* <i 
                  className="fa-solid fa-spinner fa-spin fa-4x mb-4" 
                  style={{ color: "#0d6efd" }}
                /> */}{(doctor?.showIdentity === "N") || (!doctor?.showIdentity)
          || (!doctor?.showCompanyIdentity) ||
          (doctor?.showCompanyIdentity === "N")?<>
                    <h2 className="mb-2 error-title">Identity not verified!</h2>
                    <p className="text-muted">Please search to other doctor, this profile is not verified.</p></>:
                    ((doctor?.kycAccept !=="Y") || (!doctor?.kycAccept))?
                  <><h2 className="mb-2 error-title">Kyc not done!</h2>
                    <p className="text-muted">Please search to other doctor, this profile has not done kyc yet.</p></>:
                    <><h2 className="mb-2 error-title">Identity not verified!</h2>
                    <p className="text-muted">Please search to other doctor, this profile is not verified.</p></>}
                  </div>
                </div>
              </div>
            </div>
          </>) : (<div>
            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
              <div className="container">
                <div className="row align-items-center inner-banner">
                  <div className="col-md-12 col-12 text-center">
                    <nav aria-label="breadcrumb" className="page-breadcrumb">
                      {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/main-page"><i className="isax isax-home-15" /></a></li>
                    <li className="breadcrumb-item" aria-current="page">Doctors</li>
                    <li className="breadcrumb-item active">Doctor Profile</li>
                  </ol> */}
                      <h2 className="breadcrumb-title">Doctor Profile</h2>
                    </nav>
                  </div>
                </div>
              </div>
              <div className="breadcrumb-bg">
                <img src="assets/img/bg/breadcrumb-bg-01.png" alt="img" className="breadcrumb-bg-01" />
                <img src="assets/img/bg/breadcrumb-bg-02.png" alt="img" className="breadcrumb-bg-02" />
                <img src="assets/img/bg/breadcrumb-icon.png" alt="img" className="breadcrumb-bg-03" />
                <img src="assets/img/bg/breadcrumb-icon.png" alt="img" className="breadcrumb-bg-04" />
              </div>
            </div>
            {/* /Breadcrumb */}
            {/* Page Content */}
            <div className="content">
              <div className="container">
                {/* Doctor Widget */}
                <div className="card doc-profile-card" >
                  <div className="card-body">
                    <div className="doctor-widget doctor-profile-two row align-items-center" >
                      <div className="doc-info-left col-xl-6 col-lg-6 col-md-12 col-12">
                        <div className="doctor-img" >
                          <img src={`${serverConfig.BASE_URL}/uploads/${doctor?.bufferProfileImg}`} className="img-fluid" alt="User "
                            onError={(e) => {
                              e.target.onerror = null; // prevents infinite loop
                              e.target.src = "assets/img/doctor.png";
                            }} />
                        </div>
                        <div className="doc-info-cont d-flex flex-column align-items-center align-items-md-start text-center text-md-start">

                          {isTodayAvailable && (
                            <span className="badge doc-avail-badge bg-success mb-2 text-light">
                              <i className="fa-solid fa-circle me-1" />
                              Available
                            </span>
                          )}

                          <h4 className="doc-name" >
                            Dr. {doctor.firstName}{" "}
                            {doctor.lastName}
                            <img src="assets/img/icons/badge-check.svg" alt="Img" className="ms-2" />
                          </h4>

                          <h4 className="doc-name" >
                            <span className="badge doctor-role-badge" >
                              <i className="fa-solid fa-circle me-1" />
                              {doctor.designationName}
                            </span>
                          </h4>

                          <p className="mb-1" style={{ color: 'blue', fontWeight: '600' }}>{doctor?.qualification}</p>
                          <p className="mb-1" style={{ color: 'green' }}>Speaks : {doctor?.language}</p>

                          <p className="address-detail" style={{ color: 'Black', fontWeight: '500' }}>
                            <span className="loc-icon ">
                              <i className="feather-map-pin" style={{ color: 'Black', fontWeight: '600' }} />
                            </span>
                            {doctor.companyAddress}
                          </p>

                          <p className="address-detail">
                            <span
                              className="view-text"
                              role="button"
                              onClick={(e) => handleClick(e, "clinic")}
                            >
                              ( View Location )
                            </span>
                          </p>

                        </div>
                      </div>
                      <div className="doc-info-right col-xl-6 col-lg-6 col-md-12 col-12 mt-lg-0">
                        <ul className="doctors-activities" style={{ marginTop: '-20px' }}>
                          <li>
                            <div className="hospital-info">
                              {/* <span className="list-icon"><img src="assets/img/icons/watch-icon.svg" alt="Img" /></span>
                    <p>Full Time, Online Therapy Available</p> */}
                            </div>
                            {/* <ul className="sub-links">
                        <li><a href="/" role="button"><i className="feather-heart" /></a></li>
                        <li><a href="/" role="button"><i className="feather-share-2" /></a></li>
                        <li><a href="/" role="button"><i className="feather-link" /></a></li>
                      </ul> */}
                          </li>
                          <li>
                            <div className="hospital-info">
                              {/* <span className="list-icon"><img src="assets/img/icons/thumb-icon.svg" alt="Img" /></span>
                    <p><b>94% </b> Recommended</p> */}
                            </div>
                          </li>
                          <li>
                            <div className="hospital-info">
                              <span className="list-icon"><img src="assets/img/icons/building-icon.svg" alt="Img" /></span>
                              <p>{doctor.companyName}</p>
                            </div>
                            <h5 className="accept-text"><span><i className="feather-check" /></span>Accepting New Patients</h5>
                          </li>
                          <li>
                            {/* <div className="rating">
                        <i className="fas fa-star filled" />
                        <i className="fas fa-star filled" />
                        <i className="fas fa-star filled" />
                        <i className="fas fa-star filled" />
                        <i className="fas fa-star filled" />
                        <span>5.0</span>
                        <a href="/"
                        onClick={(e) => e.preventDefault()}
                        role="button" className="d-inline-block average-rating">150 Reviews</a>
                      </div> */}
                            <ul className="contact-doctors">
                              {appointmentTypes?.chat === 'Y' && (
                                <li>
                                  <a href="/"
                                    onClick={(e) => e.preventDefault()}
                                    role="button">
                                    <span className="bg-grey"><i className="feather-message-square" /></span>Chat
                                  </a>
                                </li>
                              )}
                              {appointmentTypes?.audioCall === 'Y' && (
                                <li>
                                  <a href="/"
                                    onClick={(e) => e.preventDefault()}
                                    role="button">
                                    <span className="bg-grey"><i className="feather-phone-forwarded" /></span>Audio Call
                                  </a>
                                </li>
                              )}
                              {appointmentTypes?.videoCall === 'Y' && (
                                <li>
                                  <a href="/"
                                    onClick={(e) => e.preventDefault()}
                                    role="button">
                                    <span className="bg-grey"><i className="feather-camera" /></span>Video Call
                                  </a>
                                </li>
                              )}
                              {appointmentTypes?.homeVisit === 'Y' && (
                                <li>
                                  <a href="/"
                                    onClick={(e) => e.preventDefault()}
                                    role="button">
                                    <span className="bg-grey"><i className="feather-home" /></span>Home Visit
                                  </a>
                                </li>
                              )}
                              {appointmentTypes?.clinic === 'Y' && (
                                <li>
                                  <a href="/"
                                    onClick={(e) => e.preventDefault()}
                                    role="button">
                                    <span className="bg-grey"><i className="feather-briefcase" /></span>Clinic
                                  </a>
                                </li>
                              )}
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="doc-profile-card-bottom">
                      <ul>
                        {doctor?.noOfAppointments>20?
                        <li>
                          <span className="bg-blue"><img src="assets/img/icons/calendar3.svg" alt="Img" /></span>
                          {(doctor?.noOfAppointments > 1000) ? 1000 :
 (doctor?.noOfAppointments > 500) ? 500 :
 (doctor?.noOfAppointments > 100) ? 100 :
 (doctor?.noOfAppointments > 50) ? 50 :
 (doctor?.noOfAppointments > 20) ? 20 :
 <></>}+ Appointments Booked
                        </li>:<></>}
                        {doctor?.experienceYears?
                        <li>
                          <span className="bg-dark-blue"><i class="fa-solid fa-user-doctor" style={{ color: 'white' }}></i></span>
                          In Practice for {doctor?.experienceYears}+ Years
                        </li>:<></>}
                        {doctor?.pricing?
                        <li>
                          <span className="bg-dark-blue"><i class="fa-solid fa-comment-medical" style={{ color: 'white' }}></i></span>
                          <strong style={{ color: 'blue', fontSize: '16px' }}>Consultation fee:   </strong> <span style={{ color: 'red', fontSize: '16px', fontWeight: 'bold', marginLeft: '10px' }}> &#8377;{doctor?.pricing}</span>
                        </li>:<></>}
                      </ul>
                      <div className="bottom-book-btn d-flex flex-wrap justify-content-between align-items-center" >

                        <div className="clinic-booking" >
                          <a className="apt-btn" 
                            href={`/booking?doctorId=${doctor.userId}`}
                          //                   role="button"
                          // //                      href={isTodayAvailable ? `/booking?doctorId=${doctor.userId}` : "#"}
                          // onClick={(e) => {
                          //   if (!isTodayAvailable) {
                          //     e.preventDefault();
                          //     alert("Sorry slots are not available!");
                          //   }
                          // }}
                          >Book Appointment</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Doctor Widget */}
                <div className="doctors-detailed-info">
                  <ul className="information-title-list">
                    <li className="active">
                      <a href="/" onClick={(e) => handleClick(e, "doc_bio")}>Doctor Bio</a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => handleClick(e, "experience")}>Experience</a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => handleClick(e, "services")}>Treatments</a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => handleClick(e, "availability")}>Availability</a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => handleClick(e, "clinic")}>Clinics</a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => handleClick(e, "review")}>Review</a>
                    </li>
                  </ul>
                  <div className="doc-information-main mt-4">
                    <div className="doc-information-details bio-detail" id="doc_bio">
                      <div className="detail-title">
                        <h4>Doctor Bio</h4>
                      </div>
                      <p
                        dangerouslySetInnerHTML={{
                          __html:
                            doctor?.usersProfile?.bio?.trim()
                              ? doctor.usersProfile.bio
                              : "The best doctor in the city.",
                        }}
                      ></p>
                      {/*                 
                <a href="/" role="button" className="show-more d-flex align-items-center">
                See More<i className="fa-solid fa-chevron-down ms-2" /></a> */}
                    </div>
                    <div className="doc-information-details" id="experience" style={{ marginBottom: "0px", paddingBottom: "0px" }}>
                      <div className="doc-information-details" id="experience" style={{ marginBottom: "0px", paddingBottom: "0px" }}>
                        <div className="detail-title">
                          <h4>Practice Experience</h4>
                        </div>

                        {experiences?.map((exp) => (
                          <div className="row align-items-center" key={exp.id}>
                            {/* Image Column */}
                            <div className="col-md-2 text-center position-relative">
                              <img
                                src={`${serverConfig.BASE_URL}/uploads/experience/${exp?.image}`}
                                alt="Experience"
                                className="img-thumbnail"
                                onError={(e) => {
                                  e.target.onerror = null; // prevents infinite loop
                                  e.target.src = "assets/img/doctor.png";
                                }}
                              />
                            </div>
                            {/* Experience Description Column */}
                            <div className="col-md-10">
                              <div
                                className="border rounded p-2"
                                style={{
                                  backgroundColor: "#f8f9fa",
                                  minHeight: "80px",
                                  fontSize: "15px",
                                  color: "#333",
                                  marginTop: "15px",
                                }}
                                dangerouslySetInnerHTML={{ __html: exp?.experience }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                      {/* <div className="detail-title">
              <h4>Practice Experience</h4>
            </div>
            <div className="experience-info">
              <div className="experience-logo">
                <span><img src="assets/img/icons/experience-logo-01.svg" alt="Img" /></span>
              </div>
              <div className="experience-content">
                <h5>Cambridge University Hospital, NHS Foundation Trust Cambridge</h5>
                <ul className="ent-list">
                  <li>ENT </li>
                  <li>Cambridge</li>
                </ul>
                <ul className="date-list">
                  <li>Dec 2020 - Jan 2022 </li>
                  <li>2 Years 2 months</li>
                </ul>
                <p>Experienced in a wide variety of medical settings, with particular expertise in diagnostics, primary care and emergency medicine.</p>
              </div>
            </div>
            <div className="experience-info">
              <div className="experience-logo">
                <span><img src="assets/img/icons/experience-logo-02.svg" alt="Img" /></span>
              </div>
              <div className="experience-content mb-0">
                <h5>Hill Medical Hospital, Newcastle</h5>
                <ul className="ent-list">
                  <li>ENT </li>
                  <li>Cambridge</li>
                </ul>
                <ul className="date-list">
                  <li>Dec 2022 - Jan 2022 </li>
                  <li>1 Years 1 months</li>
                </ul>
                <p>Experienced in a wide variety of medical settings, with particular expertise in diagnostics, primary care and emergency medicine.</p>
              </div>
            </div> */}
                    </div>
                    <div className="doc-information-details" id="insurence">
                      {/* <div className="detail-title slider-nav d-flex justify-content-between align-items-center">
              <h4>Insurance  Accepted (6)</h4>
              <div className="nav nav-container slide-1" />
            </div>
            <div className="insurence-logo-slider owl-carousel">
              <div className="insurence-logo">
                <span><img src="assets/img/icons/insurence-logo-01.svg" alt="Img" /></span>
              </div>
              <div className="insurence-logo">
                <span><img src="assets/img/icons/insurence-logo-02.svg" alt="Img" /></span>
              </div>
              <div className="insurence-logo">
                <span><img src="assets/img/icons/insurence-logo-03.svg" alt="Img" /></span>
              </div>
              <div className="insurence-logo">
                <span><img src="assets/img/icons/insurence-logo-04.svg" alt="Img" /></span>
              </div>
              <div className="insurence-logo">
                <span><img src="assets/img/icons/insurence-logo-05.svg" alt="Img" /></span>
              </div>
              <div className="insurence-logo">
                <span><img src="assets/img/icons/insurence-logo-06.svg" alt="Img" /></span>
              </div>
              <div className="insurence-logo">
                <span><img src="assets/img/icons/insurence-logo-03.svg" alt="Img" /></span>
              </div>
              <div className="insurence-logo">
                <span><img src="assets/img/icons/insurence-logo-04.svg" alt="Img" /></span>
              </div>
            </div> */}
                    </div>
                    <div className="doc-information-details" id="speciality">
                      <div className="detail-title">
                        <h4>Speciality</h4>
                      </div>
                      {/* <ul className="special-links">
                        <li><a href="#">Orthopedic Consultation</a></li>
                        <li><a href="#">Delivery Blocks</a></li>
                        <li><a href="#">Ultrasound Injection</a></li>
                        <li><a href="#">Tooth Bleaching</a></li>
                        <li><a href="#">Tooth Bleaching</a></li>
                        <li><a href="#">Cosmetic</a></li>
                      </ul> */}
                      <ul className="special-links">
                        {(specialities && specialities.length > 0) ? (
                          specialities.map((spec) => (
                            <li key={spec.usersSpecialityId}>
                              <a href="/" role="button" onClick={(e) => { e.preventDefault() }}>{spec.speciality}</a>
                            </li>
                          ))
                        ) : (
                          <li><em>No specialities available.</em></li>
                        )}
                      </ul>

                    </div>
                    <div className="doc-information-details" id="services">
                      {/* <div className="detail-title">
                  <h4>Services &amp; Pricing</h4>
                </div>
                <ul className="special-links">
                  <li><a href="#">Orthopedic Consultation <span>$52</span></a></li>
                  <li><a href="#">Delivery Blocks <span>$24</span></a></li>
                  <li><a href="#">Ultrasound Injection <span>$31</span></a></li>
                  <li><a href="#">Tooth Bleaching <span>$20</span></a></li>
                  <li><a href="#">Tooth Bleaching <span>$15</span></a></li>
                  <li><a href="#">Cosmetic <span>$10</span></a></li>
                </ul> */}
                      <div className="detail-title">
                        <h4>Services</h4>
                      </div>
                      <ul className="special-links">
                        {services && services.length > 0 ? (
                          services.map((item) => (
                            <li key={item.userServicesId}>
                              <a href="/" role="button" onClick={(e) => { e.preventDefault() }}>{item.service}</a> {/* Replace $50 with actual price if you have it */}
                            </li>
                          ))
                        ) : (
                          <li><em>No services available.</em></li>
                        )}
                      </ul>
                    </div>
                    <div className="doc-information-details" id="availability">
                      <div className="detail-title slider-nav d-flex justify-content-between align-items-center">
                        <h4>Availability</h4>
                        <div className="nav nav-container slide-2" />
                      </div>

                      <div className="availability-slots-slider">
                        <Swiper
                          modules={[Navigation]}
                          spaceBetween={10}
                          navigation
                          slidesPerView={1}
                          breakpoints={{
                            320: { slidesPerView: 1 },
                            480: { slidesPerView: 2 },
                            768: { slidesPerView: 3 },
                            1024: { slidesPerView: 4 },
                          }}
                        >
                          {availability.map((slot, index) => (
                            <SwiperSlide key={index}>
                              <div
                                style={{
                                  backgroundColor: "#f0f4ff",
                                  padding: "15px",
                                  borderRadius: "8px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  height: "100%",
                                }}
                              >
                                <div style={{ textAlign: "center", width: "100%" }}>
                                  <h6
                                    style={{
                                      fontSize: "16px",
                                      marginBottom: "5px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {slot.day}
                                  </h6>
                                  <span style={{ fontSize: "14px", color: "#555" }}>
                                    {formatTime(slot.openingTime)} -{" "}
                                    {formatTime(slot.closingTime)}
                                  </span>
                                </div>
                              </div>
                            </SwiperSlide>
                          ))}
                        </Swiper>

                      </div>


                      {/* <div className="detail-title slider-nav d-flex justify-content-between align-items-center">
                  <h4>Availability</h4>
                  <div className="nav nav-container slide-2" />
                </div>
                <div className="availability-slots-slider owl-carousel">
                  <div className="availability-date">
                    <div className="book-date">
                      <h6>Wed Feb 2024</h6>
                      <span>01:00 - 02:00 PM</span>
                    </div>
                  </div>
                  <div className="availability-date">
                    <div className="book-date">
                      <h6>Wed Feb 2024</h6>
                      <span>01:00 - 02:00 PM</span>
                    </div>
                  </div>
                  <div className="availability-date">
                    <div className="book-date">
                      <h6>Wed Feb 2024</h6>
                      <span>01:00 - 02:00 PM</span>
                    </div>
                  </div>
                  <div className="availability-date">
                    <div className="book-date">
                      <h6>Wed Feb 2024</h6>
                      <span>01:00 - 02:00 PM</span>
                    </div>
                  </div>
                  <div className="availability-date">
                    <div className="book-date">
                      <h6>Wed Feb 2024</h6>
                      <span>01:00 - 02:00 PM</span>
                    </div>
                  </div>
                  <div className="availability-date">
                    <div className="book-date">
                      <h6>Wed Feb 2024</h6>
                      <span>01:00 - 02:00 PM</span>
                    </div>
                  </div>
                  <div className="availability-date">
                    <div className="book-date">
                      <h6>Wed Feb 2024</h6>
                      <span>01:00 - 02:00 PM</span>
                    </div>
                  </div>
                  <div className="availability-date">
                    <div className="book-date">
                      <h6>Wed Feb 2024</h6>
                      <span>01:00 - 02:00 PM</span>
                    </div>
                  </div>
                </div> */}
                    </div>
                    <div className="doc-information-details" id="clinic">
                      <div className="detail-title">
                        <h4>Clinics &amp; Locations</h4>
                      </div>
                      <div className="clinic-loc">
                        <div className="row align-items-center">
                          <div className="col-lg-7">
                            <div className="clinic-info row">
                              <div className=" col-sm-4 col-12 mb-3 mb-sm-0">{logoUrl && (
                                <img
                                  src={`${serverConfig.BASE_URL}/uploads/company/${logoUrl}`}
                                  className="clinic-img img-fluid"
                                  alt="Company Logo"
                                  onError={(e) => {
                                    e.target.onerror = null; // prevents infinite loop
                                    e.target.src = "assets/img/hospital.jpg";
                                  }}
                                />
                              )}</div>
                              <div className="detail-clinic col-sm-8 col-12 ">
                                <h5>{doctor?.companyName} - </h5>
                                {/* <span>{doctor?.consultationFee} / Appointment</span> */}
                                <p>{doctor?.companyAddress}</p>
                              </div>
                            </div>
                            {/* <div className="col-12 avail-time-slot">
                          <Swiper
                            modules={[Navigation, FreeMode]}
                            spaceBetween={10}
                            slidesPerView="auto"
                            navigation={true}
                            freeMode={true}
                            style={{ padding: "10px 0" }}
                          >
                            {availability.map((slot, index) => (
                              <SwiperSlide key={index} style={{ width: "180px" }}>
                                <div
                                  style={{
                                    backgroundColor: "#f0f4ff",
                                    padding: "15px",
                                    borderRadius: "8px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div style={{ textAlign: "center", width: "100%" }}>
                                    <h6 style={{ fontSize: "16px", marginBottom: "5px", fontWeight: "600" }}>
                                      {slot.day}
                                    </h6>
                                    <span style={{ fontSize: "14px", color: "#555" }}>
                                      {formatTime(slot.openingTime)} - {formatTime(slot.closingTime)}
                                    </span>
                                  </div>
                                </div>
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        </div> */}
                          </div>
                          <div className="col-lg-5">
                            <div className="contact-map d-flex">
                              <iframe src={(doctor?.mapSrcLocation) ? `${doctor?.mapSrcLocation}` : `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10961.953555788214!2d85.03847511330235!3d25.612578791242136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ed570008ecf537%3A0x33adf148709750f1!2sGola%20road!5e1!3m2!1sen!2sin!4v1773143536923!5m2!1sen!2sin`} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="some thing" />
                              {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3193.7301009561315!2d-76.13077892422932!3d36.82498697224007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89bae976cfe9f8af%3A0xa61eac05156fbdb9!2sBeachStreet%20USA!5e0!3m2!1sen!2sin!4v1669777904208!5m2!1sen!2sin" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="some thing"/> */}
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    {/* <div className="doc-information-details" id="membership">
            <div className="detail-title">
              <h4>Membership</h4>
            </div>
            <div className="member-ship-info">
              <span className="mem-check"><i className="fa-solid fa-check" /></span>
              <p>Affiliate members include related allied health professionals- evidence based 
                (Dietitians, Physiotherapist, Occupational therapist and Clinical Psychologist) who will 
                team up with allopathic physicians to 
                support the Lifestyle Medicine movement in India through ISLM.
              </p>
            </div>
            <div className="member-ship-info mb-0">
              <span className="mem-check"><i className="fa-solid fa-check" /></span>
              <p>Physician members include the allopathic doctors only (MBBS, MD, MS, DM, MCH, DNB or equivalent degree) 
                who hold a valid medical license as recognized by the Medical Council of India.
              </p>
            </div>
          </div>
          <div className="doc-information-details" id="awards">
            <div className="detail-title slider-nav d-flex justify-content-between align-items-center">
              <h4>Awards</h4>
              <div className="nav nav-container slide-3" />
            </div>
            <div className="awards-slider owl-carousel">
              <div className="award-card">
                <div className="award-card-info">
                  <span><img src="assets/img/icons/bookmark-star.svg" alt="Img" /></span>
                  <h5>Award Name (2021)</h5>
                  <p>evidence based (Dietitians, Physiotherapist, Occupational therapist and Clinical)</p>
                </div>
              </div>
              <div className="award-card">
                <div className="award-card-info">
                  <span><img src="assets/img/icons/bookmark-star.svg" alt="Img" /></span>
                  <h5>Award Name (2022)</h5>
                  <p>evidence based (Dietitians, Physiotherapist, Occupational therapist and Clinical)</p>
                </div>
              </div>
              <div className="award-card">
                <div className="award-card-info">
                  <span><img src="assets/img/icons/bookmark-star.svg" alt="Img" /></span>
                  <h5>Award Name (2023)</h5>
                  <p>evidence based (Dietitians, Physiotherapist, Occupational therapist and Clinical)</p>
                </div>
              </div>
              <div className="award-card">
                <div className="award-card-info">
                  <span><img src="assets/img/icons/bookmark-star.svg" alt="Img" /></span>
                  <h5>Award Name (2024)</h5>
                  <p>evidence based (Dietitians, Physiotherapist, Occupational therapist and Clinical)</p>
                </div>
              </div>
              <div className="award-card">
                <div className="award-card-info">
                  <span><img src="assets/img/icons/bookmark-star.svg" alt="Img" /></span>
                  <h5>Award Name (2020)</h5>
                  <p>evidence based (Dietitians, Physiotherapist, Occupational therapist and Clinical)</p>
                </div>
              </div>
            </div>
          </div>
          <div className="doc-information-details" id="bussiness_hour">
            <div className="detail-title">
              <h4>Business Hours</h4>
            </div>
            <div className="hours-business">
              <ul>
                <li>
                  <div className="today-hours">
                    <h6>Today</h6>
                    <span>5 Feb 2024</span>
                  </div>
                  <div className="availed">
                    <span className="badge doc-avail-badge"><i className="fa-solid fa-circle" />Available </span>
                    <p>07:00 AM - 09:00 PM</p>
                  </div>
                </li>
                <li>
                  <h6>Monday</h6>
                  <p>07:00 AM - 09:00 PM</p>
                </li>
                <li>
                  <h6>Tuesday</h6>
                  <p>07:00 AM - 09:00 PM</p>
                </li>
                <li>
                  <h6>Wednesday</h6>
                  <p>07:00 AM - 09:00 PM</p>
                </li>
                <li>
                  <h6>Thursday</h6>
                  <p>07:00 AM - 09:00 PM</p>
                </li>
                <li>
                  <h6>Friday</h6>
                  <p>07:00 AM - 09:00 PM</p>
                </li>
                <li>
                  <h6>Saturday</h6>
                  <p>07:00 AM - 09:00 PM</p>
                </li>
                <li>
                  <h6>Sunday</h6>
                  <p>07:00 AM - 09:00 PM</p>
                </li>
              </ul>
            </div>
          </div> */}
                    {/* <div className="doc-information-details" id="review">
                <div className="detail-title">
                  <h4>Reviews (200)</h4>
                </div>
                <div className="doc-review-card">
                  <div className="user-info-review">
                    <div className="reviewer-img">
                      <a href="/" role="button" className="avatar-img"><img src="assets/img/clients/client-13.jpg" alt="some" /></a>
                      <div className="review-star">
                        <a href="/" role="button">kadajsalamander</a>
                        <div className="rating">
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <span>5.0 | 2 days ago</span>
                        </div>
                      </div>
                    </div>
                    <span className="thumb-icon"><i className="fa-regular fa-thumbs-up" />Yes,Recommend for Appointment</span>
                  </div>
                  <p>Thank you for this informative article! I've had a couple of hit-and-miss experiences with
                    freelancers in the past, and I realize now that I wasn't vetting them properly. Your checklist
                    for choosing the right freelancer is going to be my go-to from now on
                  </p>
                  <a href="/" role="button" className="reply d-flex align-items-center"><i className="fa-solid fa-reply me-2" />Reply</a>
                </div>
                <div className="doc-review-card">
                  <div className="user-info-review">
                    <div className="reviewer-img">
                      <a href="/" role="button" className="avatar-img"><img src="assets/img/clients/client-14.jpg" alt="some" /></a>
                      <div className="review-star">
                        <a href="/" role="button">Dane jose</a>
                        <div className="rating">
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <span>5.0 | 1 Months ago</span>
                        </div>
                      </div>
                    </div>
                    <span className="thumb-icon"><i className="fa-regular fa-thumbs-up" />Yes,Recommend for Appointment</span>
                  </div>
                  <p>As a freelancer myself, I find this article spot on! It's important for clients to
                    understand what to look for in a freelancer and how to foster a good working relationship.
                    The point about mutual respect
                    and clear communication is key in my experience. Well done
                  </p>
                  <a href="/" role="button" className="reply d-flex align-items-center"><i className="fa-solid fa-reply me-2" />Reply</a>
                </div>
                <div className="doc-review-card mb-0">
                  <div className="user-info-review">
                    <div className="reviewer-img">
                      <a href="/" role="button" className="avatar-img"><img src="assets/img/clients/client-15.jpg" alt="some " /></a>
                      <div className="review-star">
                        <a href="/" role="button">Dane jose</a>
                        <div className="rating">
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <span>5.0 | 15 days ago</span>
                        </div>
                      </div>
                    </div>
                    <span className="thumb-icon"><i className="fa-regular fa-thumbs-up" />Yes,Recommend for Appointment</span>
                  </div>
                  <p>Great article! I've bookmarked it for future reference. I'd love to read more about managing long-term relationships with freelancers, if you have any tips on that.
                  </p>
                  <a href="/" role="button" className="reply d-flex align-items-center"><i className="fa-solid fa-reply me-2" />Reply</a>
                  <div className="replied-info">
                    <div className="user-info-review">
                      <div className="reviewer-img">
                        <a href="/" role="button" className="avatar-img"><img src="assets/img/clients/client-15.jpg" alt="img" /></a>
                        <div className="review-star">
                          <a href="/" role="button">Robert Hollenbeck</a>
                        </div>
                      </div>
                    </div>
                    <p>Thank you for your comment and I will try to make a another post on that topic.
                    </p>
                    <a href="/" role="button" className="reply d-flex align-items-center"><i className="fa-solid fa-reply me-2" />Reply</a>
                  </div>
                  {/* Pagination */}
                    {/*
                  <div className="pagination dashboard-pagination">
                    <ul>
                      <li>
                        <a href="/" role="button" className="page-link prev-link"><i className="fa-solid fa-chevron-left me-2" />Prev</a>
                      </li>
                      <li>
                        <a href="/" role="button" className="page-link active">1</a>
                      </li>
                      <li>
                        <a href="/" role="button" className="page-link">2</a>
                      </li>
                      <li>
                        <a href="/" role="button" className="page-link">3</a>
                      </li>
                      <li>
                        <a href="/" role="button" className="page-link">4</a>
                      </li>
                      <li>
                        <a href="/" role="button" className="page-link">5</a>
                      </li>
                      <li>
                        <a href="/" role="button" className="page-link">6</a>
                      </li>
                      <li>
                        <a href="/" role="button" className="page-link next-link">Next<i className="fa-solid fa-chevron-right ms-2" /></a>
                      </li>
                    </ul>
                  </div> */}
                    {/* /Pagination */}
                    {/*</div>
              </div> */}
                  </div>
                </div>
              </div>
            </div>
            {/* /Page Content */}
          </div>)}
    </>

  )
}
